import { render, staticRenderFns } from "./print.vue?vue&type=template&id=47b860f4&scoped=true&lang=html&"
import script from "./print.vue?vue&type=script&lang=js&"
export * from "./print.vue?vue&type=script&lang=js&"
import style0 from "./print.vue?vue&type=style&index=0&id=47b860f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b860f4",
  null
  
)

component.options.__file = "print.vue"
export default component.exports